import React from 'react';
import './Subtitle.css'

const Subtitle = () => (
    <div className='subtitle'>
        #PHP #Laravel #Vue #AI-Assisted-Development
    </div>
);

export default Subtitle;
